<template>
  <div>
  <Breadcrumbs main="Request" title="Card Management" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-3 pr-sm-0 box-col-12">
          <div class="file-sidebar">
            <div class="card">
              <div class="card-body">
                <ul>
                <li>
                <router-link to="/requestManagement/card">
                    <div class="btn btn-primary">
                      <feather type="folder"></feather>
                      Card Management
                    </div>
                    </router-link>
                  </li>
                  <li>
                  <router-link to="/requestManagement/token">
                    <div class="btn btn-light">
                      <feather type="toggle-right"></feather>
                      Hard Token Request
                    </div>
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/requestManagement/form-A">
                    <div class="btn btn-light">
                      <feather type="pocket"></feather>
                      Form A
                    </div>
                    </router-link>
                  </li>
                  <li>
                    <router-link to="/requestManagement/cheque">
                    <div class="btn btn-light">
                      <feather type="book"></feather>
                      Cheque Request
                    </div>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-9 col-md-12 box-col-12">
          <div class="file-content">
            <div class="card">
            <div v-if="loading" class="loader-12"></div>
              <div class="card-header">
                <h5>Card Management</h5>
                <span>Initiate Card Request, Block and Unblock Cards, Hotlist Cards, Pin Retrieval.</span>
              </div>
              <div id="RequestFormSection" class="animated fadeIn">
                  <div class="card-body">
                    <div class="row" v-show="cardStep == 1">
                      <div class="col-xl-4 col-md-6 box-col-6 wrapper xl-50" v-for="item in cardInfo" :key="item.id" style="cursor:pointer" @click="selectAction(item.id)">
                        <div class="card ecommerce-widget">
                          <div class="card-body support-ticket-font">
                            <div class="row">
                              <div class="col-7">
                                <h5 class="total-num counter">{{ item.title }}</h5>
                                <span>{{ item.description }}</span>
                              </div>
                              <div class="col-5">
                                <div class="text-md-right icon-wrapper">
                                  <i class="fa fa-angle-right text-danger fa-2x" aria-hidden="true"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-show="cardStep == 2">
                      <!-- <p class="text-danger" style="font-size:16px;" v-if="cardTrackingdetails" >{{pendingText}} {{'on ' + cardTrackingdetails.AccountNumber}}</p> -->
                      <div v-if="getNewCards && getNewCards.length < 1" class="text-center">
                        <p class="text-danger text-center" style="font-size:16px;">No Active Cards</p>
                        <button @click="cardStep--" type="button" class="btn btn-warning btn-sm">Go Back</button>
                      </div>
                      <p v-if="isRequest" class="text-danger text-center" style="font-size:16px;">Please wait...</p>
                      <button v-if="isRequest" @click="cardStep--" type="button" class="btn mt-4 btn-warning btn-sm">Go Back</button>
                      <div v-if="getNewCards && getNewCards.length > 0">
                        <div class="d-flex justify-content-between">
                          <p class="text-status">Card status: <span :class="getNewCards[current].cardStatus === 'Active' ? 'text-success': 'text-danger'">{{getNewCards[current].cardStatus}}</span></p>
                          <div class="d-flex">
                            <p class="arrow text-status" @click="getNewCardsInfo(getNewCards[current])" data-toggle="modal" data-target="#exampleModalCenter" v-if="!otherCardInfo[current].state">Show details</p>
                            <h6 class="arrow" v-else @click="hideCardInfo(current)">Hide details</h6>
                          </div>
                        </div>
                        <div class="d-flex mb-3">
                          <p style="font-size:16px" class="mb-2">Account Number: <span v-for="account in getNewCards[current].accounts" :key="account.id" class="text-danger mr-2">{{account.accountNumber}}</span></p>
                        </div>
                        <div id="slider" class="mt-5">
                          <transition-group tag="div" :name="transitionName" class="slides-group">
                            <div :key="current" class="slide">
                              <!--  -->
                                <div class="row">
                                  <div class="col-lg-6">
                                    <img src="@/assets/TAJimages/TAJBank-card.png" class="img-fluid" style="max-width: 350px" alt="card front">
                                    <h3 class="pan-number">{{getNewCards[current].maskedPAN}}</h3>
                                    <p class="valid-number">{{otherCardInfo[current].expiryDate}}</p>
                                    <h3 class="card-holder-name">{{otherCardInfo[current].userAccountName}}</h3>
                                  </div>
                                  <div class="col-lg-6">
                                    <img src="@/assets/TAJimages/card-reverse_position-guide.png" class="img-fluid" style="max-width: 350px" alt="card back">
                                  </div>
                                </div>
                            </div>
                          </transition-group>
                        </div>
                        <div class="text-center d-flex justify-content-center set-mt my-5" v-if="getNewCards">
                          <i class="fa fa-arrow-left text-danger mt-1 arrow" aria-label="Previous slide" @click="slide(-1)"></i>
                          <p class="mx-5">{{current + 1}}/{{getNewCards.length}}</p>
                          <i class="fa fa-arrow-right text-danger mt-1 arrow" aria-label="Next slide" @click="slide(1)"></i>
                        </div>
                      </div>
                      <div v-if="getNewCards && getNewCards.length > 0" class="d-flex fit-mobile justify-content-between">
                        <div>
                          <button type="button" data-toggle="modal" data-target="#blockCard" @click="getNewCardsInfo(getNewCards[current])" class="btn btn-danger btn-sm mr-3" v-if="getNewCards && getNewCards[current].holdRespCode == null || ''">Block card</button>
                          <button @click="cardStep--" type="button" class="btn btn-warning last-btn btn-sm">Go Back</button>
                        </div>
                        <div>
                          <button type="button" data-toggle="modal" data-target="#hotlistCard" @click="getNewCardsInfo(getNewCards[current])" class="btn btn-dark btn-sm mr-3" v-if="getNewCards && getNewCards[current].holdRespCode == null || ''">Hotlist card</button>
                          <button type="button" data-toggle="modal" data-target="#pinRetrieval" @click="getNewCardsInfo(getNewCards[current])" class="btn btn-success btn-sm last-btn mr-3" v-if="getNewCards && getNewCards[current].holdRespCode == null || ''">Pin Retrieval</button>
                          <button type="button" data-toggle="modal" data-target="#unBlockCard" @click="getNewCardsInfo(getNewCards[current])" class="btn btn-success btn-sm last-btn mr-3" v-if="getNewCards && getNewCards[current].holdRespCode != null || ''">Unblock card</button>
                        </div>
                      </div>
                    </div>
                    <form class="theme-form is-validated" id="Submit_Transfer_Form" v-show="cardStep == 3">
                        <!-- Initiate the Transfer -->
                        <div id="InitiateTransfer" v-show="step === 1">
                          <p class="text-danger text-center" style="font-size:16px;" ref="activeText"></p>         
                            <section v-if="canCardRequest" class="mt-5">
                              <h5 class="text-danger text-center">Sample Card Design</h5>
                              <div class="row">
                                <div class="col-lg-6">
                                  <img src="@/assets/TAJimages/card-front-design.png" class="img-fluid" alt="card front" />
                                </div>
                                <div class="col-lg-6">
                                  <img src="@/assets/TAJimages/card-reverse-design.png" class="img-fluid" alt="card back" />
                                </div>
                              </div>
                              <h5 class="text-danger">Card Request Form</h5>
                              <div class="mb-3 mt-4 row">
                                  <label class="col-sm-3 col-form-label" for="AccountNumber">Select Account <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <select v-model="form.accountNumber" placeholder="Select From Account *" class="form-select acct-num" data-val-length="The field AccountNumber must be a string with a maximum length of 250." data-val-length-max="250" data-val-required="The AccountNumber field is required." id="AccountNumber" name="AccountNumber" required="required"><option value="" disabled>Select From Account *</option>
                                        <option v-for="account in availableAccounts" :value="account.accountNumber" :key="account.id">{{account.accountNumber}} (Acct No: {{account.accountName}} | Balance: {{account.availableBalance}})</option>
                                      </select>
                                      <span class="text-danger font-small-3 field-validation-valid" data-valmsg-for="AccountNumber" data-valmsg-replace="true"></span>
                                  </div>
                              </div>
                              <div class="mb-3 row">
                                  <label class="col-sm-3 col-form-label" for="location">Current Location <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <select @change="getCurrentLocation" v-model="form.currentLocationId" class="form-select acct-num" required="required"><option value="" disabled>Select To Current Location *</option>
                                      <option v-for="state in states" :value="state.id" :key="state.id">{{state.name}}</option>
                                      </select>
                                      <span class="text-danger font-small-3 field-validation-valid" data-valmsg-for="AccountNumber" data-valmsg-replace="true"></span>
                                  </div>
                              </div>
                              <div class="mb-3 row">
                                  <label class="col-sm-3 col-form-label" for="DeliveryOption">Delivery Option <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <select class="form-select acct-num" v-model="form.deliveryOption" required="required"><option value="">Select Delivery Option *</option>
                                      <option v-for="options in deliveryOptions" :value="options.id" :key="options.id">{{options.description}}</option>
                                      </select>
                                      <span class="text-danger font-small-3 field-validation-valid" data-valmsg-for="AccountNumber" data-valmsg-replace="true"></span>
                                  </div>
                              </div>
                              <div class="mb-3 row animated fadeIn" v-if="form.deliveryOption == 1 || form.deliveryOption == 3">
                                  <label class="col-sm-3 col-form-label" for="DeliveryOption">Pickup Branch <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <select class="form-select acct-num" v-model="form.branchId" required="required"><option value="">Select Pickup Branch *</option>
                                      <option v-for="location in locationBranches" :value="location.id" :key="location.id">{{location.name}}</option>
                                      </select>
                                  </div>
                              </div>
                              <div class="mb-3 row animated fadeIn" v-if="form.deliveryOption == 3">
                                    <label class="col-sm-3 col-form-label">Third-Party Name For Pickup <span class="text-danger">*</span></label>
                                    <div class="col-sm-9 col-xl-7">
                                        <input class="form-control" v-model="form.thirdPartyName" placeholder="Enter Third-Party Name" type="text" value="" />
                                    </div>
                                </div>
                                <div class="mb-3 row animated fadeIn" v-if="form.deliveryOption == 3">
                                  <label class="col-sm-3 col-form-label" for="DeliveryOption">Third-Party Means Of Identification <span class="text-danger">*</span></label>
                                  <div class="col-sm-9 col-xl-7">
                                      <select class="form-select acct-num" v-model="form.thirdPartyMeansOfId" required="required"><option value="" disabled>Select Means Of Identification for Third-Party *</option>
                                      <option v-for="id in idTypes" :value="id.id" :key="id.id">{{id.description}}</option>
                                      </select>
                                  </div>
                              </div>
                              <section class="delivery-section animated fadeIn" v-if="form.deliveryOption == 2">
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label" for="address1">Delivery Address Line 1 <span class="text-danger">*</span></label>
                                    <div class="col-sm-9 col-xl-7">
                                        <input class="form-control" v-model="form.deliveryAddressLine1" name="address1" placeholder="Enter Delivery Address Line 1" type="text" value="" maxlength="60" />
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label" for="address2">Delivery Address Line 2</label>
                                    <div class="col-sm-9 col-xl-7">
                                        <input class="form-control" v-model="form.deliveryAddressLine2" name="address2" placeholder="Enter Delivery Address Line 2" type="text" value="" maxlength="60"/>
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label" for="addresscity">Delivery City <span class="text-danger">*</span></label>
                                    <div class="col-sm-9 col-xl-7">
                                        <input class="form-control" v-model="form.deliveryAddressCity" name="addresscity" placeholder="Enter Delivery City" type="text" value="" maxlength="60"/>
                                    </div>
                                </div>
                                <div class="mb-3 row">
                                    <label class="col-sm-3 col-form-label" for="DeliveryOption">Delivery State <span class="text-danger">*</span></label>
                                    <div class="col-sm-9 col-xl-7">
                                        <select class="form-select acct-num" v-model="form.deliveryStateId" required="required"><option value="" disabled>Select Delivery State  *</option>
                                        <option v-for="state in states" :value="state.id" :key="state.id">{{state.name}}</option>
                                        </select>
                                    </div>
                                </div>
                              </section>
                              <div class="row mt-4">
                                  <div class="col-sm-12 offset-lg-3 offset-sm-0">
                                      <button type="button" @click="validate" class="btn btn-round btn-primary mr-1">
                                        <div v-if="loading">
                                          <i class='fa fa-refresh fa-spin'></i>&nbsp;Verifying Transaction...
                                        </div>
                                        <div v-else>
                                          Proceed<i class="fa fa-angle-right ml-2"></i>
                                        </div>
                                      </button>
                                      <button type="button" @click="resetForm" class="btn btn-outline-danger">Go back</button>
                                  </div>
                              </div>
                            </section>
                            <div class="row" v-if="!canCardRequest">
                              <div class="col-sm-12">
                                <button type="button" @click="backTo" class="btn btn-danger">Go back</button>
                              </div>
                            </div>
                        </div>
                        <!-- card cost -->
                        <section v-show="step === 2">
                          <div class="mb-3 row">
                              <label class="col-sm-3 col-form-label" for="BranchId">Cost Breakdown</label>
                              <div class="col-sm-9 col-xl-7">
                                  <div class="table-responsive-sm">
                                      <table class="table table-striped" width="100%">
                                          <thead class="thead-light">
                                              <tr>
                                                  <th>Item</th>
                                                  <th>Unit Cost</th>
                                                  <th>Quantity</th>
                                                  <th>Line Total</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              <tr>
                                                  <td>Card</td>
                                                  <td id="unit-cost">₦{{requestFee.feeAmount}}.00</td>
                                                  <td id="quantity">1</td>
                                                  <td id="line-total">₦{{requestFee.total}}.00</td>
                                              </tr>
                                              <tr>
                                                  <td colspan="2"></td>
                                                  <td>Total</td>
                                                  <td id="total-cost" class="text-success">₦{{requestFee.total}}.00</td>
                                              </tr>
                                          </tbody>
                                      </table>
                                  </div>
                              </div>
                          </div>
                          <br />
                            <div class="mb-3 row">
                                <div class="col-sm-9  offset-lg-3 offset-sm-0">
                                <input style="background-color: red;" type="checkbox" name="checkbox" value="check" v-model="checked"/> I have read and agree to the <a href="https://iretail.tajbank.com/files/ATM_Card.pdf" target="_blank" class="primary-color">Terms and Conditions</a> &nbsp;<br /><br />
                                    <button type="button" @click="checkedTerms" class="btn btn-primary mr-2">
                                        <div v-if="loading">
                                          <i class='fa fa-refresh fa-spin'></i>&nbsp;Please Wait...
                                        </div>
                                        <div v-else>
                                          Proceed <i class="fa fa-angle-right ml-2"></i>
                                        </div>
                                    </button>
                                    <button type="button" class="btn btn-outline-danger" @click="goBackTo">Go Back</button>
                                </div>
                            </div>
                        </section>
                        <!-- Verify Account Name and Submit Transfer Request -->
                        <div id="AccountNameVerification" v-show="step === 3">
                            <div class="mb-4 row">
                                <label class="col-sm-3 col-form-label" for="SecurityQuestion">Security Question<span class="text-danger">*</span></label>                             
                                <div class="col-sm-9 col-xl-7">
                                    <select class="form-select acct-num" v-model="form.securityQuestionId" required="required"><option value="" disabled>Select Security Question  *</option>
                                      <option v-for="question in userSecurityQuestion" :value="question.id" :key="question.id">{{question.question}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="mb-3 row">
                                <label class="col-sm-3 col-form-label" for="SecurityAnswer">Security Answer <b class="text-danger">*</b></label>
                                <div class="col-sm-9 col-xl-7">
                                    <input class="form-control" v-model="form.securityAnswer" id="SecurityAnswer" maxlength="250" name="SecurityAnswer" placeholder="Enter Security Answer *" :type="answerType" />
                                    <span @click="showAnswer" class="pull-right show-pin">{{ answerType === 'password' ? 'show': 'hide'}}</span>
                                </div>
                            </div>
                            <div class="mb-3 row">
                                <label class="col-sm-3 col-form-label" for="Token">Transaction Pin <span class="text-danger">*</span></label>
                                <div class="col-sm-9 col-xl-7">
                                    <input @keypress="isNumber" @paste.prevent class="form-control" min="0" v-model="form.transactionPin" pattern="\d*" maxlength="4"  placeholder="Enter Your Transaction Pin *" required="required" :type="type" value="" />
                                    <div class="show-hide" @click="showPin"><span :class="type === 'password' ? 'show': 'hide'"></span></div>
                                    <span class="text-danger font-small-3 field-validation-valid" data-valmsg-for="Token" data-valmsg-replace="true"></span>
                                </div>
                            </div>
                            <br />
                            <div class="mb-3 row">
                                <div class="col-sm-9  offset-lg-3 offset-sm-0">
                                    <button type="button" class="btn btn-primary mr-2" @click="initiateCardRequest">
                                      <div v-if="loading">
                                        <i class='fa fa-refresh fa-spin'></i>&nbsp;Please Wait...
                                      </div>
                                      <div v-else>
                                        Submit <i class="fa fa-check ms-2"></i>
                                      </div>
                                    </button>
                                    <button type="button" class="btn btn-outline-danger" @click="goBackTo">Go Back</button>
                                </div>
                            </div>
                        </div>
                    </form>
                    <section v-show="cardStep == 4">
                      <div v-if="allServiceRequest.length > 0" class="pb-4">
                        <h5 class="text-danger mb-4">Card Request History</h5>
                        <div class="row">
                          <div class="col-lg-6" v-for="data in allServiceRequest" :key="data.id">
                            <div class="card p-4" @click="getRequestById(data.id)" data-target="#viewRequest" data-toggle="modal" style="cursor:pointer;">
                              <div class="d-flex justify-content-between align-items-center">
                                <h6 style="width:200px;">Card Request made on {{ data.createdDate | formatDate }}</h6>
                                <span><i class="fa fa-eye text-danger"></i></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <p class="text-danger text-center" style="font-size:16px;" v-else>No Pending Card Request History </p>
                      <button type="button" @click="cardStep = 1" class="btn btn-danger">Go back</button>
                    </section>
                  </div>
              </div>

              <!-- Request Success Response -->
              <div id="RequestSuccessResponseSection" v-show="step === 4" class="animated fadeIn" style="display:block">
                <div class="card-body">
                    <div class="align-content-center align-items-center justify-content-center p-2 text-center">
                        <img src="@/assets/TAJimages/notification/success.png" alt="Error Icon image" class="img-fluid" />
                        <h5 class="text-bold-700 mb-2 text-success"><i class="feather icon-check-circle fa-2x"></i> REQUEST SUCCESSFUL!</h5>
                        <p>Your request has been submitted successfully!</p>
                        <router-link to="/dashboard/default">
                            <a class="btn btn-primary btn-round">Go To Home<i class="fa fa-home ml-2"></i></a>
                        </router-link>
                    </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal to show details -->
  <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h6>Enter Transaction Pin</h6>
          <button type="button" class="close" data-dismiss="modal" @click="closeModal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="mb-3 row">
              <label class="col-sm-12 col-form-label">Transaction Pin <span class="text-danger">*</span></label>
              <div class="col-sm-12 col-xl-12">
                  <input @keypress="isNumber" @paste.prevent class="form-control" min="0" v-model="form.transactionPin" pattern="\d*" maxlength="4"  placeholder="Enter Your Transaction Pin *" required="required" :type="type" value="" />
                  <div class="show-hide" @click="showPin"><span :class="type === 'password' ? 'show': 'hide'"></span></div>
              </div>
          </div>
          <div class="row mt-4">
            <div class="col-sm-12">
                <button type="button" @click="getCardInfo(getNewCards[current].maskedPAN, current)" class="btn btn-round btn-primary mr-1">
                <div v-if="isLoadingDetails">
                  <i class='fa fa-refresh fa-spin'></i>&nbsp;Please wait...
                </div>
                <div v-else>
                  Proceed<i class="fa fa-angle-right ml-2"></i>
                </div>
                </button>
                <button type="button" @click="closeModal" class="btn btn-outline-danger">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- modal to block card -->
  <div class="modal fade" id="blockCard" tabindex="-1" role="dialog" aria-labelledby="blockCardTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h6>Block Card</h6>
          <button type="button" class="close" data-dismiss="modal" @click="closeModal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p class="text-dark">Block card means your card will be temporarily blocked and you can also unblock it at anytime using the unblock card feature.</p>
          <div class="mb-4 row">
            <label class="col-sm-3 col-form-label">Reason <span class="text-danger">*</span></label>
            <div class="col-sm-9">
                <select v-model="blockReason" placeholder="Select Reason *" class="form-select acct-num" required="required">
                  <option value="" disabled>Select Reason *</option>
                  <option v-for="reason in getBlockCardReason" :value="reason.id" :key="reason.id">{{reason.description}}</option>
                </select>
            </div>
          </div>
          <div class="mb-3 row">
              <label class="col-sm-3 col-form-label">Transaction Pin <span class="text-danger">*</span></label>
              <div class="col-sm-9">
                  <input @keypress="isNumber" @paste.prevent class="form-control" min="0" v-model="form.transactionPin" pattern="\d*" maxlength="4"  placeholder="Enter Your Transaction Pin *" required="required" :type="type" value="" />
                  <div class="show-hide" @click="showPin"><span :class="type === 'password' ? 'show': 'hide'"></span></div>
              </div>
          </div>
          <div class="row mt-4">
            <div class="col-sm-12">
                <button type="button" @click="blockCard('blockCard')" class="btn btn-round btn-primary mr-1">
                <div v-if="isLoadingDetails">
                  <i class='fa fa-refresh fa-spin'></i>&nbsp;Please wait...
                </div>
                <div v-else>
                  Proceed<i class="fa fa-angle-right ml-2"></i>
                </div>
                </button>
                <button type="button" @click="closeModal" class="btn btn-outline-danger">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- modal to unblock card -->
  <div class="modal fade" id="unBlockCard" tabindex="-1" role="dialog" aria-labelledby="blockCardTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h6>Unblock Card</h6>
          <button type="button" class="close" data-dismiss="modal" @click="closeModal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="mb-3 row">
              <label class="col-sm-3 col-form-label">Transaction Pin <span class="text-danger">*</span></label>
              <div class="col-sm-9">
                  <input @keypress="isNumber" @paste.prevent class="form-control" min="0" v-model="form.transactionPin" pattern="\d*" maxlength="4"  placeholder="Enter Your Transaction Pin *" required="required" :type="type" value="" />
                  <div class="show-hide" @click="showPin"><span :class="type === 'password' ? 'show': 'hide'"></span></div>
              </div>
          </div>
          <div class="row mt-4">
            <div class="col-sm-12">
                <button type="button" @click="blockCard('unblockCard')" class="btn btn-round btn-primary mr-1">
                <div v-if="isLoadingDetails">
                  <i class='fa fa-refresh fa-spin'></i>&nbsp;Please wait...
                </div>
                <div v-else>
                  Proceed<i class="fa fa-angle-right ml-2"></i>
                </div>
                </button>
                <button type="button" @click="closeModal" class="btn btn-outline-danger">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- modal to hotlist card -->
  <div class="modal fade" id="hotlistCard" tabindex="-1" role="dialog" aria-labelledby="blockCardTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h6>Hotlist Card</h6>
          <button type="button" class="close" data-dismiss="modal" @click="closeModal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p class="text-dark">Hotlist card means customers card will be permanently blocked and not useable.</p>
          <div class="mb-4 row">
            <label class="col-sm-3 col-form-label">Reason <span class="text-danger">*</span></label>
            <div class="col-sm-9">
                <select v-model="blockReason" placeholder="Select Reason *" class="form-select acct-num" required="required">
                  <option value="" disabled>Select Reason *</option>
                  <option v-for="reason in getBlockCardReason" :value="reason.id" :key="reason.id">{{reason.description}}</option>
                </select>
            </div>
          </div>
          <div class="mb-3 row">
              <label class="col-sm-3 col-form-label">Transaction Pin <span class="text-danger">*</span></label>
              <div class="col-sm-9">
                  <input @keypress="isNumber" @paste.prevent class="form-control" min="0" v-model="form.transactionPin" pattern="\d*" maxlength="4"  placeholder="Enter Your Transaction Pin *" required="required" :type="type" value="" />
                  <div class="show-hide" @click="showPin"><span :class="type === 'password' ? 'show': 'hide'"></span></div>
              </div>
          </div>
          <div class="row mt-4">
            <div class="col-sm-12">
                <button type="button" @click="blockCard('hotlistCard')" class="btn btn-round btn-primary mr-1">
                <div v-if="isLoadingDetails">
                  <i class='fa fa-refresh fa-spin'></i>&nbsp;Please wait...
                </div>
                <div v-else>
                  Proceed<i class="fa fa-angle-right ml-2"></i>
                </div>
                </button>
                <button type="button" @click="closeModal" class="btn btn-outline-danger">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- modal to pin retrieval card -->
  <div class="modal fade" id="pinRetrieval" tabindex="-1" role="dialog" aria-labelledby="blockCardTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h6>Pin Retrieval</h6>
          <button type="button" class="close" data-dismiss="modal" @click="closeModal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <section v-show="pinRetrievalStep == 1">
            <div class="mb-3 row">
              <label class="col-sm-3 col-form-label">Card Last 4 Digits <span class="text-danger">*</span></label>
              <div class="col-sm-9">
                  <input @keypress="isNumber" class="form-control" v-model="cardLast4Digits" maxlength="4"  placeholder="Card Last 4 Digits *" required="required" />
              </div>
            </div>
            <div class="mb-3 row">
                <label class="col-sm-3 col-form-label">Transaction Pin <span class="text-danger">*</span></label>
                <div class="col-sm-9">
                    <input @keypress="isNumber" @paste.prevent class="form-control" min="0" v-model="form.transactionPin" pattern="\d*" maxlength="4"  placeholder="Enter Your Transaction Pin *" required="required" :type="type" value="" />
                    <div class="show-hide" @click="showPin"><span :class="type === 'password' ? 'show': 'hide'"></span></div>
                </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12">
                  <button type="button" @click="pinRetrieval" class="btn btn-round btn-primary mr-1">
                  <div v-if="isLoadingDetails">
                    <i class='fa fa-refresh fa-spin'></i>&nbsp;Please wait...
                  </div>
                  <div v-else>
                    Proceed<i class="fa fa-angle-right ml-2"></i>
                  </div>
                  </button>
                  <button type="button" @click="closeModal" class="btn btn-outline-danger">Cancel</button>
              </div>
            </div>
          </section>
          <section v-show="pinRetrievalStep == 2" class="animated fadeIn mb-4">
            <div class="align-content-center align-items-center justify-content-center p-2 text-center">
              <img src="@/assets/TAJimages/notification/success.png" alt="Error Icon image" class="img-fluid" />
              <h5 class="text-bold-700 mb-2 text-success"><i class="feather icon-check-circle fa-2x"></i> REQUEST SUCCESSFUL!</h5>
              <p>Your request was successful!</p>
              <p style="font-size:17px" class="text-dark">Your PIN is <span class="text-danger font-weight-bold">{{ showCardPin ? temporaryPin : 'XXXX' }}</span> 
              <img src="@/assets/TAJimages/SVG/eye-1.svg" v-if="!showCardPin" @click="showCardPin = !showCardPin" alt="" class="cursor-pointer ml-3 mb-1">
              <img src="@/assets/TAJimages/SVG/hidden.png" v-else @click="showCardPin = !showCardPin" alt="" class="cursor-pointer ml-3 mb-1">
              </p>
              <router-link to="/dashboard/default">
                  <a @click="goHomeReload" class="btn btn-primary btn-round">Go To Home<i class="fa fa-home ml-2"></i></a>
              </router-link>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="viewRequest" tabindex="-1" role="dialog" aria-labelledby="blockCardTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h6>Card Request Information</h6>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p v-if="isRequestLoading" class="text-danger text-center py-3">Please wait...</p>
          <div v-else class="table-responsive mt-0">
              <table id="example" class="display table table-striped" style="width:100%">
                  <thead class="font-weight-bold">
                    <tr class="text-left">
                      <th>Date Requested</th>
                      <th>Account Number</th>
                      <th>Card Type</th>
                      <th>Branch</th>
                      <th>Current Location</th>
                      <th>Delivery Address</th>
                      <th>Delivery Option</th>
                      <th>Delivery State</th>
                      <th>Third Party Name</th>
                      <th>Fee</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                <tbody>
                <tr class="text-left">
                    <td>{{cardTrackingdetails.CreatedDate | moment}}</td>
                    <td>{{cardTrackingdetails.AccountNumber}}</td>
                    <td>{{cardTrackingdetails.CardType == 1 ? 'Verve': 'Master Card'}}</td>
                    <td>{{cardTrackingdetails.Branch ? cardTrackingdetails.Branch.Name : 'N/A'}}</td>
                    <td>{{cardTrackingdetails.CurrentLocation ? cardTrackingdetails.CurrentLocation.Name : 'N/A'}}</td>
                    <td>{{cardTrackingdetails.DeliveryAddressLine1 ? cardTrackingdetails.DeliveryAddressLine1 : 'N/A' }}</td>
                    <td>{{cardTrackingdetails.DeliveryOption === 1 ? 'Pickup' : cardTrackingdetails.DeliveryOption === 2 ? 'Delivery' : 'Third Party' }}</td>
                    <td>{{cardTrackingdetails.DeliveryState ? cardTrackingdetails.DeliveryState : 'N/A'}}</td>
                    <td>{{cardTrackingdetails.ThirdPartyName ? cardTrackingdetails.ThirdPartyName : 'N/A'}}</td>
                    <td>{{new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(cardTrackingdetails.Fee ? cardTrackingdetails.Fee : 'N/A')}}</td>
                    <td :class="statusClassName">{{cardTrackingdetails.Status}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  import { mapState, mapActions } from 'vuex';
  import $ from 'jquery';
  import moment from 'moment';
  import { encrypt, decrypt } from '@/_services/encryption';
  export default {
    filters: {
      moment: function (date) {
        return moment(date).format('YYYY-MM-DD hh:mm:A');
      },
      formatDate: function (date) {
        return moment(date).format('DD/MM/YYYY');
      },
    },
    data:() => ({
      form: {
        accountNumber: '',
        currentLocationId: '',
        cardType: 1,
        deliveryOption: '',
        deliveryStateId: '',
        thirdPartyMeansOfId: '',
        deliveryAddressCity: '',
        deliveryAddressLine1: '',
        deliveryAddressLine2: '',
        branchId: '',
        thirdPartyName: '',
        securityQuestionId: '',
        securityAnswer: '',
        transactionPin: '',
        platform: 1,
      },
      blockReason: '',
      hotlistReason: '',
      cardLast4Digits: '',
      temporaryPin: '1234',
      step: 1,
      cardStep: 1,
      pinRetrievalStep: 1,
      showCardPin: false,
      checked: false,
      loading: false,
      isLoading: false,
      isLoadingDetails: false,
      isRequestLoading: false,
      type: 'password',
      answerType: 'password',
      isSecurityQuestion: localStorage.getItem('isSecurityQuestion'),
      cardInfo: [
        { id: 1, title: 'Card Details', description: 'Click to view details' },
        { id: 2, title: 'Card Request', description: 'Click to continue' },
        { id: 3, title: 'Card History', description: 'Click to view history' }
      ],
      otherCardInfo:[
        { id: 0, userAccountName: 'XXXXXXXX', expiryDate: 'XXXX', state: false },
        { id: 1, userAccountName: 'XXXXXXXX', expiryDate: 'XXXX', state: false },
        { id: 2, userAccountName: 'XXXXXXXX', expiryDate: 'XXXX', state: false },
        { id: 3, userAccountName: 'XXXXXXXX', expiryDate: 'XXXX', state: false },
        { id: 4, userAccountName: 'XXXXXXXX', expiryDate: 'XXXX', state: false },
        { id: 5, userAccountName: 'XXXXXXXX', expiryDate: 'XXXX', state: false },
      ],
      current: 0,
      direction: 1,
      transitionName: 'fade',
      show: false,
      slides: [
        { className: 'blue' },
        { className: 'red' },
        { className: 'yellow' },
        { className: 'yellow' },
        { className: 'yellow' },
        { className: 'yellow' },
      ],
      getAllCards: [],
      blockCardDetails: {},
      canCardRequest: false,
      showTrackingInfo: false,
      pendingText: '',
      isRequest: false,
      statusClassName: 'text-dark',
      allRequest: []
    }),
    computed: {
      ...mapState({
        states: state => state.authentication.states,
        // eslint-disable-next-line no-confusing-arrow
        userAccounts: state => state.dashboard.dashboardData ? state.dashboard.dashboardData.accounts : [],
        cardTypes: state => state.requests.cardTypes,
        allBranches: state => state.requests.allBranches,
        locationBranches: state => state.requests.locationBranches,
        idTypes: state => state.authentication.idTypes,
        deliveryOptions: state => state.requests.deliveryOptions,
        userSecurityQuestion: state => state.authentication.userSecurityQuestion,
        userDetails: state => state.dashboard.dashboardData.customerDetails.userName,
        requestFee: state => state.requests.requestFee,
        getCardDetails: state => state.cards.getCards.cards,
        getBlockCardReason: state => state.cards.blockCardReason,
        getNewCards: state => state.cards.getCards.cards,
        canUserRequest: state => state.cards.getCards.canRequestCard,
        availableAccounts: state => state.cards.availableAccounts,
        cardTrackingdetails: state => state.requests.singleServiceRequest,
        allServiceRequest: state => state.requests.serviceRequest
      }),
    },
    async mounted() {
      this.show = true;
      this.getUserAvailableAccount();
      this.fetchUserCards();
      this.checkCardRequest();
      await this.$store.dispatch('getStates');
      await this.$store.dispatch('requests/getCardTypes');
      await this.$store.dispatch('getIdTypes');
      await this.$store.dispatch('requests/getAllBranches');
      await this.$store.dispatch('requests/getDeliveryOptions');
      await this.$store.dispatch('requests/getRequestFee', 4);
      await this.$store.dispatch('cards/getBlockCardReason');
      await this.$store.dispatch('getUserSecurityQuestion', { username: this.userDetails, customerType: 2 })

      if(this.isSecurityQuestion === 'true') {
        this.$router.push('/settings/reset-security-question');
      }
    },
    methods : {
      ...mapActions('requests', ['getCardRequest', 'getServiceRequestById']),
      async getRequestById (id) {
        this.showTrackingInfo = true;
        this.isRequestLoading = true
        this.pendingText = 'You Have Pending/Active Card';
        try {
          await this.getServiceRequestById(id)
          var status = '';
            var statusClass = '';
            switch (this.cardTrackingdetails.Status) {
            case 0:
              status = 'Successful';
              statusClass = 'text-success';
              break;
            case 1:
              status = 'Failed';
              statusClass = 'text-danger';
              break;
            case 2:
              status = 'Logged For Approval';
              statusClass = 'text-warning';
              break;
            case 3:
              status = 'Pending';
              statusClass = 'text-warning';
              break;
            case 4:
              status = 'Processing';
              statusClass = 'text-warning';
              break;
            case 5:
              status = 'Processed';
              statusClass = 'text-warning';
              break;
            case 6:
              status = 'Debit Failed';
              statusClass = 'text-danger';
              break;
            case 7:
              status = 'Picked Up';
              statusClass = 'text-success';
              break;
            case 8:
              status = 'Approved';
              statusClass = 'text-success';
              break;
            case 9:
              status = 'Delivered';
              statusClass = 'text-success';
              break;
            case 10:
              status = 'Declined';
              statusClass = 'text-danger';
              break;
            }
            this.cardTrackingdetails.Status = status;
            this.statusClassName = statusClass;
            this.isRequestLoading = false;
        } catch (error) {
          this.isRequestLoading = false;
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            title:'Oops...',
            text: objError.errors[0],
            type:'error',
            confirmButtonText: 'Ok',
          });
        }
      },
      async fetchUserCards() {
        this.isRequest = true;
        await this.$store.dispatch('cards/getNewUserCards').then((response) => {
          this.isRequest = false;
        });
      },
      async getUserAvailableAccount() {
        const response = await this.$store.dispatch('cards/getAvailableAccounts');
        const decryptedData = decrypt(response.data);
        const userParseData = JSON.parse(decryptedData);
        const accounts = userParseData;
        if(accounts.length < 1 || accounts === null) {
          this.canCardRequest = false;
          this.$refs.activeText.innerHTML = 'You have pending card request';
        } else {
          this.canCardRequest = true;
        }
      },
      backTo() {
        this.cardStep = 1;
      },
      selectAction(id) {
        switch (id) {
        case 1:
          this.cardStep = 2;
          break;
        case 2:
          this.cardStep = 3;
          break;
          case 3:
          this.cardStep = 4;
          break;
        }
      },
      slide(dir) {
        this.direction = dir;
        dir === 1
          ? (this.transitionName = 'slide-next')
          : (this.transitionName = 'slide-prev');
        var len = this.slides.length;
        this.current = (this.current + dir % len + len) % len;
      },
      checkCardRequest() {
        const data = {
          status: 3,
          type: 4,
          pageIndex: 0,
          pageSize: 100,
          orderBy: 'CreatedDate',
          byDescending: true
        };
        this.loading = true;
        this.$store.dispatch('requests/getServiceRequest', data).then(() => {
          this.loading = false;
        }).catch((error) => {
          this.loading = false;
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            title:'Oops...',
            text: objError.errors[0],
            type:'error',
            confirmButtonText: 'Ok',
          });
        });
      },
      fetchCardDetails() {
        this.$store.commit('cards/SET_USER_CARDS', []);
        this.otherCardInfo.forEach((item) => {
          item.state = false;
          item.userAccountName = 'XXXXXXXX';
          item.expiryDate = 'XXXX';
        });
        const accountNumber = {
          accountNumbers: [this.form.accountNumber],
        };
        this.isLoading = false;
        this.isLoadingDetails = true;
        this.$store.dispatch('cards/getUserCards', accountNumber).then(() => {
          this.isLoadingDetails = false;
          this.current = 0;
        }).catch((error) => {
          this.$store.commit('cards/SET_USER_CARDS', []);
          this.isLoadingDetails = false;
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            title:'Oops...',
            text: objError.errors[0],
            type:'error',
            confirmButtonText: 'Ok',
          });
        });
      },
      // get card details 
      getCardInfo(cardNumber, current) {
        const data = {
          accountNumber: this.form.accountNumber,
          maskedPan: cardNumber,
          transactionPin: this.form.transactionPin,
          platform: 1,
        };
        this.isLoadingDetails = true;
        this.$store.dispatch('cards/getUserCardDetails', data).then((response) => {
          const decryptedData = decrypt(response.data);
          const userParseData = JSON.parse(decryptedData);
          const cardDetails = userParseData.cardDetails;
          this.otherCardInfo[current].state = true;
          $('#exampleModalCenter').modal('hide');
          this.isLoadingDetails = false;
          this.form.transactionPin = '';
          String.prototype.splice = function(idx, rem, str) {
            return this.slice(0, idx) + str + this.slice(idx + Math.abs(rem));
          };
          var result = cardDetails.expiryDate.splice(2, 0, '/');
          var panNumber = cardDetails.pan.replace(/([0-9]{4})(?=.)/g, '$1 ');
          this.getNewCards[current].maskedPAN = panNumber;
          this.otherCardInfo[current].userAccountName = cardDetails.c1NameOnCard;
          this.otherCardInfo[current].expiryDate = result;
        }).catch((error) => {
          this.isLoadingDetails = false;
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            title:'Oops...',
            text: objError.errors[0],
            type:'error',
            confirmButtonText: 'Ok',
          });
        });
      },
      hideCardInfo(current) {
        this.isLoading = false;
        this.isLoadingDetails = true;
        this.$store.dispatch('cards/getNewUserCards').then(() => {
          this.isLoadingDetails = false;
          this.otherCardInfo.forEach((item, index) => {
            if(index !== current) {
              this.otherCardInfo[index].state = false;
              this.otherCardInfo[index].userAccountName = 'XXXXXXXX';
              this.otherCardInfo[index].expiryDate ='XXXX';
            }
          });
          this.closeModal();
          this.otherCardInfo[current].userAccountName = 'XXXXXXXX';
          this.otherCardInfo[current].expiryDate ='XXXX';
          this.otherCardInfo[current].state = false;
        }).catch((error) => {
          this.$store.commit('cards/SET_USER_CARDS', []);
          this.isLoadingDetails = false;
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            title:'Oops...',
            text: objError.errors[0],
            type:'error',
            confirmButtonText: 'Ok',
          });
        });
      },
      getNewCardsInfo(details) {
        this.blockCardDetails = details;
        this.form.accountNumber = details.accountNumber;
      },
      blockCard(type) {
        this.blockCardDetails.branchCode = this.blockCardDetails.branchCode ? this.blockCardDetails.branchCode : '005';
        const data = {
          ...this.blockCardDetails,
          blockReason: this.blockReason,
          transactionPin: this.form.transactionPin,
          platform: 1,
        };
        if(type === 'blockCard') {
          if(this.form.transactionPin === '') {
            this.$swal({
              title: 'Oops...',
              text: 'Please enter your transaction pin',
              type: 'error',
              confirmButtonText: 'Ok',
            });
          } else {
            this.isLoadingDetails = true;
            this.$store.dispatch('cards/blockUserCard', data).then(() => {
              this.isLoadingDetails = false;
              $('#blockCard').modal('hide');
              this.$swal({
                title: 'Success',
                text: 'Card has been blocked successfully',
                type: 'success',
                confirmButtonText: 'Ok',
              }).then(() => {
                window.location.reload();
              });
            }).catch((error) => {
              this.isLoadingDetails = false;
              const decryptedError = decrypt(error.response.data);
              const objError = JSON.parse(decryptedError);
              this.$swal({
                title:'Oops...',
                text: objError.errors[0],
                type:'error',
                confirmButtonText: 'Ok',
              });
            });
          }
        } else if(type === 'hotlistCard') {
          if(this.form.transactionPin === '') {
            this.$swal({
              title: 'Oops...',
              text: 'Please enter your transaction pin',
              type: 'error',
              confirmButtonText: 'Ok',
            });
          } else {
            this.isLoadingDetails = true;
            this.$store.dispatch('cards/hotlistUserCard', data).then(() => {
              this.isLoadingDetails = false;
              $('#hotlistCard').modal('hide');
              this.$swal({
                title: 'Success',
                text: 'Card has been hotlisted successfully',
                type: 'success',
                confirmButtonText: 'Ok',
              }).then(() => {
                window.location.reload();
              });
            }).catch((error) => {
              this.isLoadingDetails = false;
              const decryptedError = decrypt(error.response.data);
              const objError = JSON.parse(decryptedError);
              this.$swal({
                title:'Oops...',
                text: objError.errors[0],
                type:'error',
                confirmButtonText: 'Ok',
              });
            });
          }
        } else if (type === 'unblockCard') {
          if(this.form.transactionPin === '') {
            this.$swal({
              title: 'Oops...',
              text: 'Please enter your transaction pin',
              type: 'error',
              confirmButtonText: 'Ok',
            });
          } else {
            if (this.form.transactionPin) {
              const cardNumber = this.blockCardDetails.maskedPAN;
              const formData = {
                accountNumber: this.form.accountNumber,
                pan: cardNumber,
                transactionPin: this.form.transactionPin,
                platform: 1,
              };
              this.isLoadingDetails = true;
              this.$store.dispatch('cards/unblockUserCard', formData).then(() => {
                this.isLoadingDetails = false;
                $('#unBlockCard').modal('hide');
                this.$swal({
                  title: 'Success',
                  text: 'Card has been unblocked successfully',
                  type: 'success',
                  confirmButtonText: 'Ok',
                }).then(() => {
                  window.location.reload();
                });
              }).catch((error) => {
                this.isLoadingDetails = false;
                const decryptedError = decrypt(error.response.data);
                const objError = JSON.parse(decryptedError);
                this.$swal({
                  title:'Oops...',
                  text: objError.errors[0],
                  type:'error',
                  confirmButtonText: 'Ok',
                });
              });
            } 
          }
        }
      },
      pinRetrieval() {
        const data = {
          accountNumber: this.form.accountNumber,
          transactionPin: this.form.transactionPin,
          cardLast4Digits: this.cardLast4Digits,
          platform: 1,
        };
        if(this.form.transactionPin === '') {
          this.$swal({
            title: 'Oops...',
            text: 'Please enter your transaction pin',
            type: 'error',
            confirmButtonText: 'Ok',
          });
        } else {
          this.isLoadingDetails = true;
          this.$store.dispatch('cards/retrieveUserPin', data).then((response) => {
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            this.isLoadingDetails = false;
            this.pinRetrievalStep = 2;
            this.temporaryPin = userParseData.pin;
          }).catch((error) => {
            this.isLoadingDetails = false;
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.$swal({
              title:'Oops...',
              text: objError.errors[0],
              type:'error',
              confirmButtonText: 'Ok',
            });
          });
        }
      },
      isNumber(event) {
        // prevent user to enter non-numeric value
        if (event.keyCode < 48 || event.keyCode > 57) {
          event.returnValue = false;
        }
      },
      checkedTerms() {
        if (this.checked === true) {
          this.step = 3;
        } else {
          this.$swal({
            title: 'Oops...',
            text: 'Please accept the terms and conditions',
            type: 'error',
            confirmButtonText: 'Ok'
          });
        }
      },
      // show pin
      showPin() {
        this.type = this.type === 'password' ? 'text' : 'password';
      },
      showAnswer() {
        this.answerType = this.answerType === 'password' ? 'text' : 'password';
      },
      goNext() {
        this.step++;
      },
      getCurrentLocation(event) {
        const locationId = event.target.value;
        try {
          this.$store.dispatch('requests/getLocationBranches', locationId);
        }catch(error) {
          // sweet alert
          const decryptedError = decrypt(error.response.data);
          const objError = JSON.parse(decryptedError);
          this.$swal({
            title: 'Oops...',
            text: objError.errors[0],
            type: 'error',
            confirmButtonText: 'Ok',
          });
        }
      },
      validate() {
        const { accountNumber, currentLocationId, deliveryOption, branchId, deliveryAddressLine1, deliveryAddressCity, deliveryStateId, thirdPartyMeansOfId, thirdPartyName } = this.form;
        if(accountNumber === '' || currentLocationId === '' || deliveryOption === '') {
          this.$swal({
            title: 'Oops...',
            text: 'Please fill all the required fields',
            type: 'error',
            confirmButtonText: 'Ok',
          });
        }
        if (deliveryOption === 1) {
          if (branchId === '' || accountNumber === '' || currentLocationId === '' || deliveryOption === '') {
            this.$swal({
              title: 'Oops...',
              text: 'Please fill all required fields',
              type: 'error',
              confirmButtonText: 'Ok',
            });
            return false;
          } else {
            this.form.deliveryAddressLine1 = '';
            this.form.deliveryAddressLine2 = '';
            this.form.deliveryAddressCity = '';
            this.form.deliveryStateId = '';
            this.form.thirdPartyMeansOfId = '';
            this.form.thirdPartyName = '';
            this.step = 2;
          }
        }
        // check if delivery option is 2 then check if address is filled
        if (deliveryOption === 2) {
          if (deliveryAddressLine1 === '' || deliveryAddressCity === '' || deliveryStateId === '' || accountNumber === '' || currentLocationId === '' || deliveryOption === '') {
            this.$swal({
              title: 'Oops...',
              text: 'Please fill all required fields',
              type: 'error',
              confirmButtonText: 'Ok',
            });
            return false;
          } else {
            this.form.branchId = '';
            this.form.thirdPartyMeansOfId = '';
            this.form.thirdPartyName = '';
            this.step = 2;
          }
        }
        // check if delivery option is 3 then check if third party detials are filled
        if (deliveryOption === 3) {
          if (thirdPartyMeansOfId === '' || thirdPartyName === '' || accountNumber === '' || currentLocationId === '' || deliveryOption === '') {
            this.$swal({
              title: 'Oops...',
              text: 'Please fill all required fields',
              type: 'error',
              confirmButtonText: 'Ok',
            });
            return false;
          } else {
            this.form.deliveryAddressLine1 = '';
            this.form.deliveryAddressLine2 = '';
            this.form.deliveryAddressCity = '';
            this.form.deliveryStateId = '';
            this.step = 2;
          }
        }
      },
      initiateCardRequest() {
        const pickup = {
          accountNumber: this.form.accountNumber,
          currentLocationId: this.form.currentLocationId,
          cardType: this.form.cardType,
          deliveryOption: this.form.deliveryOption,
          branchId: this.form.branchId,
          securityQuestionId: this.form.securityQuestionId,
          securityAnswer: this.form.securityAnswer,
          transactionPin: this.form.transactionPin,
          platform: this.form.platform,
        };
        const delivery = {
          accountNumber: this.form.accountNumber,
          currentLocationId: this.form.currentLocationId,
          cardType: this.form.cardType,
          deliveryOption: this.form.deliveryOption,
          deliveryAddressLine1: this.form.deliveryAddressLine1,
          deliveryAddressLine2: this.form.deliveryAddressLine2,
          deliveryAddressCity: this.form.deliveryAddressCity,
          deliveryStateId: this.form.deliveryStateId,
          securityQuestionId: this.form.securityQuestionId,
          securityAnswer: this.form.securityAnswer,
          transactionPin: this.form.transactionPin,
          platform: this.form.platform,
        };
        const thirdParty = {
          accountNumber: this.form.accountNumber,
          currentLocationId: this.form.currentLocationId,
          cardType: this.form.cardType,
          branchId: this.form.branchId,
          deliveryOption: this.form.deliveryOption,
          thirdPartyMeansOfId: parseInt(this.form.thirdPartyMeansOfId),
          thirdPartyName: this.form.thirdPartyName,
          securityQuestionId: this.form.securityQuestionId,
          securityAnswer: this.form.securityAnswer,
          transactionPin: this.form.transactionPin,
          platform: this.form.platform,
        };
        const checkDeliveryOption = this.form.deliveryOption === 1 ? pickup : this.form.deliveryOption === 2 ? delivery : thirdParty;
        // check if all fields are filled
        if(this.form.securityQuestionId === '' || this.form.securityAnswer === '' || this.form.transactionPin === '') {
          this.$swal({
            title: 'Oops...',
            text: 'Please fill all required fields',
            type: 'error',
            confirmButtonText: 'Ok',
          });
          return false;
        } else {
          this.loading = true;
          this.$store.dispatch('requests/cardRequest', checkDeliveryOption).then(() => {
            this.loading = false;
            this.step = 4;
          }).catch(error => {
            this.loading = false;
            // sweet alert
            const decryptedError = decrypt(error.response.data);
            const objError = JSON.parse(decryptedError);
            this.$swal({
              title:'Oops...',
              text: objError.errors[0],
              type:'error',
              confirmButtonText: 'Ok',
            });
          });
        }
      },
      goBackTo() {
        this.step--;
      },
      closeModal() {
        $('#exampleModalCenter').modal('hide');
        $('#blockCard').modal('hide');
        $('#hotlistCard').modal('hide');
        $('#pinRetrieval').modal('hide');
        this.form.transactionPin = '';
        this.blockReason = '';
        this.cardLast4Digits = '';
        this.pinRetrievalStep = 1;
      },
      resetForm() {
        this.cardStep = 1;
        // this.$store.commit('cards/SET_USER_CARDS', []);
        this.isLoading = false;
        this.isLoadingDetails = false;
        this.form = {
          accountNumber: '',
          nameOnCard: '',
          currentLocationId: '',
          cardType: '',
          deliveryOption: '',
          branchId: '',
          deliveryAddressLine1: '',
          deliveryAddressLine2: '',
          deliveryAddressCity: '',
          deliveryStateId: '',
          thirdPartyMeansOfId: '',
          thirdPartyName: '',
          securityQuestionId: '',
          securityAnswer: '',
          transactionPin: '',
        };
      },
      goHomeReload() {
        this.$router.push('/dashboard/default');
        window.location.reload();
      }
    },
  };
</script>
<style scoped>
p {
  letter-spacing: 0;
}
.card-design-bg {
  background-image: url(../../assets/TAJimages/TAJBank-card.png);
  background-position: center;
  background-size: cover;
  margin: -8px 0;
  position: relative;
}
.file-content .card .card-header,
.file-content .card .card-body {
  padding: 40px !important;
}
.card .card-header h5 {
    font-size: 23px;
    font-weight: 300;
}
.btn-light {
    background-color: #e6e6e6 !important;
    color: #000000!important;
    /* border-color: rgba(228, 31, 19, 0.06) !important; */
}
.theme-form select.acct-num {
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  width: 100%;
}
.form-control {
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  width: 100%;
}
.form-select {
  width: 100%;
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  color: #898989;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem
}
.form-control::placeholder {
  color: #898989;
}
.pull-right {
  color:#E41613;
}
.btn-outline-danger {
  border-color: #e6e6e6;
  color: #000;
  margin-left: 5px;
}
.swal2-actions >>> .swal2-confirm {
  background-color: #1a803f !important;
}
.loader-12 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5) url("../../assets/TAJimages/backgrounds/taj_loader_sm.gif") center center no-repeat;
  z-index: 1000;
  border-radius: 10px;
}
.pan-number {
  position: absolute;
  top: 127px;
  left: 60px;
  color: #fff;
  letter-spacing: 3px;
  font-size: 19px;
  font-weight: 400;
}
.valid-number {
  position: absolute;
  top: 150px;
  left: 162px;
  color: #fff;
  /* font-weight: 400; */
}
.card-holder-name {
  position: absolute;
  bottom: 20px;
  font-size: 16px;
  color: #fff;
  left: 60px;
}
.arrow {
  cursor: pointer;
}
/* FADE IN */
.fade-enter-active {
  transition: opacity 1s;
}
.fade-enter {
  opacity: 0;
}
/* GO TO NEXT SLIDE */
.slide-next-enter-active,
.slide-next-leave-active {
  transition: transform 0.5s ease-in-out;
}
.slide-next-enter {
  transform: translate(100%);
}
.slide-next-leave-to {
  transform: translate(-100%);
}
/* GO TO PREVIOUS SLIDE */
.slide-prev-enter-active,
.slide-prev-leave-active {
  transition: transform 0.5s ease-in-out;
}
.slide-prev-enter {
  transform: translate(-100%);
}
.slide-prev-leave-to {
  transform: translate(100%);
}
/* SLIDES CLASSES */
.blue {
  background: #4a69bd;
}
.red {
  background: #e55039;
}
.yellow {
  background: #f6b93b;
}
/* SLIDER STYLES */
body {
  overflow: hidden;
  margin: 0;
  font-size: 50px;
  font-family: "Crimson Text", sans-serif;
  color: #fff;
}
#slider {
  width: 100%;
  height: 200px;
  position: relative;
}
.slide {
  width: 100%;
  height: 200px;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-check {
  z-index: 10;
  cursor: pointer;
  border: 3px solid #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70px;
  height: 70px;
  position: absolute;
  top: calc(50% - 35px);
  left: 1%;
  transition: transform 0.3s ease-in-out;
  user-select: none;
}
.text-status {
  font-size: 17px;
  font-weight: 500;
}
.btn-next {
  left: auto;
  right: 1%;
}
.btn:hover {
  transform: scale(1.1);
}
.cursor-pointer {
  cursor: pointer;
}
@media screen and (max-width: 768px) {
  .set-mt {
    margin-top: 10rem !important;
    margin-bottom: 0 !important;
  }
  .support-ticket-font .total-num {
    font-size: 16px;
  }
  .ecommerce-widget span {
    font-size: 13px;
  }
  .last-btn {
    margin-top: 15px;
  }
  .fit-mobile {
    margin-left: 15px;
  }
}
</style>